export const EVALUATION_RUBRICS = "/api/evaluation-rubrics"
export const EVALUATION_RUBRIC = "/api/evaluation-rubrics/:param"
export const EVALUATION_RUBRIC_ACTIVATE = "/api/evaluation-rubrics/:param/activate"
export const EVALUATION_RUBRIC_CANCEL = "/api/request-evaluation-rubrics/:param/cancel"
export const EXPORT_EVALUATION_RUBRIC = "/api/evaluation-rubrics/export"
export const IMPORT_EVALUATION_RUBRIC = "/api/evaluation-rubrics/import"

export const REQUEST_EVALUATION_RUBRICS = "/api/request-evaluation-rubrics"
export const REQUEST_EVALUATION_RUBRIC = "/api/request-evaluation-rubrics/:param"
